<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-card>
              <v-card-title>Omar Garcia</v-card-title>
              <v-card-subtitle>Owner</v-card-subtitle>
              <v-card-text>
                <v-img :src="omar" class="image"></v-img>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-card>
              <v-card-title>Cathy D Hufford</v-card-title>
              <v-card-subtitle>{{ get("p-1.1") }}</v-card-subtitle>
              <v-card-text>
                <v-img :src="cathy" class="image"></v-img>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-card>
              <v-card-title>Trevor Kaplan</v-card-title>
              <v-card-subtitle>{{ get("p-1.2") }}</v-card-subtitle>
              <v-card-text>
                <v-img :src="trevor" class="image"></v-img>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-card>
              <v-card-title>Kate Garcia</v-card-title>
              <v-card-subtitle>{{ get("p-1.4") }}</v-card-subtitle>
              <v-card-text>
                <v-img :src="kate" class="image"></v-img>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-card>
              <v-card-title>Josh Hemninger</v-card-title>
              <v-card-subtitle>{{ get("p-1.5") }}</v-card-subtitle>
              <v-card-text>
                <v-img :src="josh" class="image"></v-img>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>{{ get("header-2") }}</h2>
            <p>
              {{ get("p-2.1") }}
              {{ get("company") }}
              {{ get("p-2.2") }}
            </p>
            <ol>
              <li>
                {{ get("p-2.3") }}
              </li>
              <li>{{ get("p-2.4") }}</li>
              <li>{{ get("p-2.5") }}</li>
            </ol>
            <v-img :src="office" class="image"></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
    <v-row :class="theme + '-alt-background-1'">
      <v-col cols="12">
        <h2>{{ get("header-3") }}</h2>
        <p>
          {{ get("p-3.1") }}
          {{ get("company") }}
          {{ get("p-3.2") }}
        </p>
        <ul>
          <li>Owens Corning</li>
          <li>CertainTeed</li>
          <li>GAF</li>
          <li>TAMKO</li>
          <li>Mastic</li>
          <li>Alcoa</li>
          <li>Simonton</li>
          <li>System Home Improvements</li>
        </ul>
        <p>
          {{ get("p-3.3") }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>
          {{ get("header-4") }}
        </h2>
        <p>
          {{ get("p-4.1") }}
          {{ get("company") }}
          {{ get("p-4.2") }}
          <phonenumber phone="(303) 778-8010"></phonenumber>
          {{ get("P-4.3") }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from "@/router";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";
export default {
  name: "About-Home",

  components: {
    estimate,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  created() {
    this.pageName = "about-staff";
  },

  data: () => ({
    cathy: require("@/assets/cathy.jpg"),
    josh: require("@/assets/josh.jpg"),
    kate: require("@/assets/kate.jpeg"),
    omar: require("@/assets/omar.jpg"),
    trevor: require("@/assets/trevor.jpg"),
  }),

  mixins: [localizationMixin],

  methods: {
    onAbout() {
      router.push("/about/home");
    },
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>

</style>
